import { render, staticRenderFns } from "./LatestTurnOn.vue?vue&type=template&id=9f540cb2&"
import script from "./LatestTurnOn.vue?vue&type=script&lang=js&"
export * from "./LatestTurnOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports